module.exports = __webpack_public_path__ + "static/media/luis-ricardo-avatar.e2011c7a.svg";